<template>
  <div>
    <slot
      :count="count"
      :goal="goal"
    >
      <div
        v-if="showLabel"
        class=" flex flex-row max-md:flex-wrap md:justify-between max-md:justify-center gap-x-4 mb-1 mt-0"
      >
        <p class="font-bold">
          {{ formatNumber(count) }} dyreforkjempere
        </p>
        <p>
          Hjelp oss å nå {{ formatNumber(goal || 0) }}
        </p>
      </div>
    </slot>
    <UProgress
      v-model="count"
      aria-label="Progress bar"
      size="xl"
      min="0"
      :max="goal"
    />
  </div>
</template>

<script lang="ts" setup>
const { data: { locale } } = getData()

const props = defineProps({
  showLabel: {
    type: Boolean,
    required: false,
    default: true,
  },
  mauticSegmentId: {
    type: Number,
    required: false,
    default: undefined,
  },
  mauticCampaignId: {
    type: Number,
    required: false,
    default: undefined,
  },
  sfCampaignId: {
    type: String,
    required: false,
    default: undefined,
  },
  currentCount: {
    type: Number,
    required: false,
    default: undefined,
  },
  customGoal: {
    type: Number,
    required: false,
    default: undefined,
  },
})

const goals: number[] = [
  10, 25, 50, 75, 100, 125, 150, 175, 200, 250, 300, 350, 400, 450, 500, 550, 600, 700, 800, 900, 1000, 2000, 3000, 4000, 5000, 10000, 15000, 20000, 25000, 30000, 45000, 50000, 60000, 70000, 80000, 90000, 100000,
]
const { api_endpoint } = useRuntimeConfig().public
const count = ref(0)
let initialCount: number = 0

if (typeof props.currentCount === 'number') {
  initialCount = props.currentCount
}
else if (props.sfCampaignId) {
  const { data } = await useFetch<number>(`${api_endpoint}/campaigns/${props.sfCampaignId}`, { method: 'GET' })
  initialCount = data.value || 0
}
else {
  throw new Error('[ProgressBar] there is no id to get count and count is not provided.')
}

function animateNumber(from: number, to: number, duration: number) {
  if (useIsMobile()) return count.value = to

  const start = performance.now()
  const frameRate = 20
  const frameDuration = 1000 / frameRate

  const update = (currentTime: number) => {
    const elapsed = currentTime - start
    const progress = Math.min(elapsed / duration, 1) // Cap progress at 1

    count.value = Math.max(0, Math.round(from + (to - from) * progress)) // Ensure count is always 0 or more

    if (progress < 1) setTimeout(() => requestAnimationFrame(update), frameDuration) // Continue animation with reduced frame rate
  }

  requestAnimationFrame(update) // Start the animation
}

const goal = computed(() => {
  if (props.customGoal) return props.customGoal
  else if (initialCount) {
    return [...goals]
      .sort((a: number, b: number) => a - b)
      .find(x => x > initialCount)
  }
  else return 10000
})

function formatNumber(num: number) {
  return new Intl.NumberFormat(locale).format(num)
}

onMounted(() => {
  animateNumber(count.value, initialCount, 2500)
})
</script>
